import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gqb5ebspac: FaireBrandEntity = {
  token: "b_gqb5ebspac",
  type: "brand",
  name: "Super Stock Wholesale",
  avatarUrl:
    "https://cdn.faire.com/fastly/b17e3fc04535968758a6e5f4ef5ac27e7f7283e9b3ace542bf68abb877dd7921.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f37d54a9a77ece606203370dc9748a8225cbaf8eef74dd6e073d2d99c7a25cc1.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/b17e3fc04535968758a6e5f4ef5ac27e7f7283e9b3ace542bf68abb877dd7921.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f37d54a9a77ece606203370dc9748a8225cbaf8eef74dd6e073d2d99c7a25cc1.webp",
  location: "Saddle Brook, NJ, USA",
  minimumOrderDollars: 300,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "At Super Stock Wholesale, we have proudly served the general merchandise sector for over seven years, specializing in the procurement of cosmetics, health, and beauty products. Our expertise lies in carefully curating and supplying an extensive range of quality items that cater to the diverse needs of retailers.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:59.076Z",
    importedBy: "entity-db-cli",
  },
};
